import React, { useRef, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import download from "downloadjs";
import useOnceEffect from "../../Hooks/useOnceEffect";
import Swal from "sweetalert2";
import { Url } from "../../utils/Url/Url";
import defaultLogo from "../../static/images/rsz_real-estate-building-logo-icon-vector.jpg";
const initialValues = {
  archivotest: null,
  archivotestNombre: "",
  archivotestURL: "",
  archivotestcampany: "",
  companyVacantId: 0,
  description: "",
};

function Vacante() {
  const state = {};
  const params = useParams();
  const [data, setData] = useState("");
  const [applicant, setapplicant] = useState("");
  const [testapli, settestapli] = useState(initialValues);
  const testExiste = useRef(false);
  const [btnactive, Setbtnactive] = useState(false);
  const [testdes, settestdes] = useState("");

  let history = useHistory();
  let userId = localStorage.getItem("userId");

  const getdescripciontest = () => {
    axios
      .get(
        "/company-vacant-test/description-test-by-vacant?companyVacantId=" +
          params.id
      )
      .then((result) => {
        settestdes(result.data);
      });
  };

  const getData = () => {
    axios
      .get("/company-vacant/" + params.id)
      .then((result) => {
        setData(result.data);
      })
      .catch((e) => {
        if (e.response.status === 500) {
          history.push("/user/Empleos");
        }
      });
  };

  const aplicarVacante = () => {
    if (!data.aplico) {
      axios
        .post("/company-vacant/apply-vacant/", {
          aplicarVacanteId: 0,
          fechaAplicacion: new Date(),
          habilidades: "string",
          insignia: 0,
          test: "false",
          applicantProfileId: applicant.applicantProfile.applicantProfileId,
          vacanteEmpresaId: params.id,
        })
        .then((result) => {
          getData();
        });

      sendMail(params.id);
    } else {
      axios
        .post("company-vacant/close-applicant-vacant/" + data.aplicarVacanteId)
        .then((result) => {
          toast.success("Aplicacion cancelada");
          getData();
        });
    }
  };

  const guardarVacante = async () => {
    let data = {
      aplicarVacanteId: 0,
      fechaAplicacion: new Date(),
      habilidades: "string",
      insignia: 0,
      test: "false",
      applicantProfileId: applicant.applicantProfile.applicantProfileId,
      vacanteEmpresaId: params.id,
    };

    axios
      .post("/company-vacant/vacant-favorite/", data)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
        }
      })
      .catch((e) => {
        if (e?.response && e?.response?.status === 400) {
          toast.error(e.response.data.message, { duration: 5000 });
        } else {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        }
      });
  };

  async function sendMail(companyvacantID) {
    axios.post("access/notification-vacant/" + companyvacantID);
  }

  function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  }

  function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        toast.success("Enlace de la vacante fue copiado al portapapeles", {
          duration: 4000,
        });
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  }

  function getMatches(skillsApplicant, skillsNeeded) {
    var matches = [];
    for (var i = 0; i < skillsNeeded?.length; i++) {
      for (var j = 0; j < skillsApplicant?.length; j++) {
        if (skillsNeeded[i].skillId == skillsApplicant[j].skillId)
          matches.push(skillsApplicant[j].name);
      }
    }
    return matches.length;
  }

  const h = {
    textAlign: "center",
  };

  const Downloadtestvacant = () => {
    axios
      .get("company-vacant-test/download-file?companyVacantId=" + params.id, {
        responseType: "blob", // had to add this one here
      })
      .then((result) => {
        if (result.status === 200) {
          const content = result.headers["content-type"];
          download(
            result.data,
            result.headers["filename"] ?? "Test.pdf",
            content
          );

          toast.success("Descargando", {
            duration: 4000,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error("No hay Test Disponible", { duration: 5000 });
        }
      });
  };

  const getVacantTest = () => {
    axios
      .get("company-vacant-test/test-by-vacant", {
        params: {
          companyVacantId: params.id,
        },
      })
      .then((res) => {
        if (res.data.message === "1") {
          Setbtnactive(true);
        }
      });
  };

  const fileSelectHandler = (e) => {
    let {
      target: { files },
    } = e;

    settestapli(files[0]);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    function localFile() {
      const datas = new FormData();
      //dumping required data
      datas.append("File", testapli);
      datas.append("companyVacantId", params.id);
      datas.append(
        "applicantProfileId",
        applicant.applicantProfile.applicantProfileId
      );
      datas.append("obs", "test");
      axios
        .post("/applicant-vacant-test/upload-file", datas)
        .then((result) => {
          if (result.status === 200) {
            toast.success("Archivo subido", {
              duration: 6000,
            });
          }
        })
        .catch(function (error) {
          if (error.response.status === 400) {
            toast.error("Debe agregar un archivo");
          }
        });
    }

    if (!testExiste.current) {
      localFile();
      return;
    }

    Swal.fire({
      text: "Ya existe una repuesta para esta vacante, ¿Quieres reemplazarlo?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((res) => {
      if (res.isConfirmed) {
        localFile();
      }
    });
  };

  const getApplicantTest = (applicantId) => {
    axios
      .get("applicant-vacant-test/test-by-vacant", {
        params: {
          companyVacantId: params.id,
          applicantId: applicantId,
        },
      })
      .then((res) => {
        if (res.data.message === "1") {
          testExiste.current = true;
        }
      });
  };

  useOnceEffect(() => {
    if (params.id === undefined) {
      toast.error("Vacante no disponible", {
        duration: 5000,
      });
      setTimeout(function () {
        history.push("/user/Empleos");
      }, 6000);

      return;
    }

    axios.get("access/applicant/" + userId).then((result) => {
      setapplicant(result.data);
      getApplicantTest(result.data.applicantProfile.applicantProfileId);
    });

    getData();
    getVacantTest();
    getdescripciontest();
  }, []);

  return (
    <div className="vacantes profile">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="bordered-box">
              <div className="bordered-box__container">
                <div className="job-header">
                  <div className="job-header__top">
                    <div className="job-header__name">
                      <div className="job-header__name-logo">
                        <img
                          src={
                            data.companyVacant?.companyProfileId
                              .profileImagePath !== null
                              ? data.companyVacant?.companyProfileId
                                  .profileImagePath
                              : defaultLogo
                          }
                          alt=""
                          style={{ maxWidth: "92px", maxHeight: "87px" }}
                        ></img>
                      </div>
                      <div className="job-header__name-title">
                        {data.companyVacant?.cargo ?? ""}
                      </div>
                      <div className="job-header__name-company">
                        {state.lugar}
                      </div>
                      <div className="job-header__name-location">
                        {data.companyVacant?.departmentId.name ?? ""}
                      </div>
                    </div>
                    <div
                      className="job-header__top-buttons"
                      id="job-header__bottom1"
                    >
                      <div className="job-header__notification form-check form-switch"></div>
                      <div className="job-header__apply">
                        {data.aplico ? (
                          <button
                            className="btn btn--gradient"
                            onClick={aplicarVacante}
                          >
                            Cancelar
                          </button>
                        ) : (
                          <button
                            className="btn btn--gradient"
                            data-bs-toggle="modal"
                            data-bs-target="#kr-modal"
                            data-title="Experiencia"
                            onClick={aplicarVacante}
                          >
                            Aplicar
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="job-header__middle">
                    <div className="job-header__middle-col">
                      <ul>
                        <li>
                          <strong>Publicado:</strong>{" "}
                          {data.companyVacant?.fechaPublicacion ?? ""}
                        </li>
                        <li>
                          <strong>Tipo:</strong>{" "}
                          {data.companyVacant?.tipoJornadaId.name ?? ""}
                        </li>
                        <li>
                          <strong>Experiencia:</strong>{" "}
                          {data.companyVacant?.nivelExperienciaEmpleoId.name ??
                            ""}
                        </li>
                      </ul>
                    </div>
                    <div
                      className="job-header__middle-col"
                      id="jobheader_habilidades"
                    >
                      <ul>
                        <li>
                          <strong>Habilidades: </strong>{" "}
                          {getMatches(applicant?.listSkills, data?.listSkills)}{" "}
                          / {data.listSkills?.length}
                        </li>
                      </ul>
                      <div className="job-header__middle-aptitude">
                        {data.listSkills
                          ?.map(function (lstSkills) {
                            return lstSkills.skillName;
                          })
                          .join(" - ")}
                      </div>
                    </div>
                    <div
                      className="job-header__middle-col"
                      id="jobheader_habilidades"
                    >
                      <ul>
                        <li className="view-icon">
                          <strong>Visualizaciones:</strong>{" "}
                          {data.companyVacant?.visualizaciones ?? 0}
                          <a
                            href="#"
                            onClick={() => {
                              let host = window.location.hostname;
                              //in the case host having a port, include it in the url
                              if (window.location.port) {
                                host = host + ":" + window.location.port;
                              }

                              // Asegurarse de que el protocolo sea https
                              let protocol =
                                window.location.protocol === "https:"
                                  ? "https"
                                  : "http";
                              let finalUrl = `${protocol}://${host}/compartir/vacante/${params.id}`;
                              let Title = `Vacante: ${data.companyVacant?.cargo} - ${data.companyVacant?.companyProfileId.name}`;
                              let body =
                                "Revisa esta vacante que encontre en Krezco, la red social de desarrollo profesional";
                              navigator.share({
                                title: Title,
                                url: finalUrl,
                                text: body,
                              });
                            }}
                            className="mx-3"
                          >
                            <i
                              className="fa fa-share-alt"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                        <li className="carpet-icon">
                          <strong>Postulaciones:</strong>{" "}
                          {data.companyVacant?.cantidadAplicantes ?? 0}
                          <span className="mx-3" onClick={guardarVacante}>
                            <i
                              className="fa fa-bookmark"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="job-header__middle-col">
                      <ul className="toolset"></ul>
                    </div>
                  </div>

                  <div className="job-header__bottom">
                    <div className="job-header__bottom-left">
                      <ul className="job-header__bottom-button">
                        <li className="py-1">
                          <button
                            className="btn btn--purple"
                            disabled={!btnactive}
                            onClick={Downloadtestvacant}
                          >
                            Descargar Test
                          </button>
                        </li>

                        <li className="py-1 px-1">
                          <input
                            id="achivo-input"
                            disabled={!btnactive}
                            type="file"
                            onChange={fileSelectHandler}
                          />
                        </li>

                        <li className="py-1">
                          <button
                            className="btn btn--purple"
                            disabled={!btnactive}
                            onClick={onSubmit}
                          >
                            Subir Respuesta
                          </button>
                        </li>
                      </ul>
                    </div>

                    {/*Descripcion Test */}
                    <div className="job-header__bottom-left">
                      <ul>
                        <strong>Descripción: </strong> <br />
                        {testdes}
                      </ul>
                    </div>

                    <div className="job-header__bottom-right">
                      <div className="job-header__bottom-salary">
                        Salario:{" "}
                        {data.companyVacant?.monedaId.codigo +
                          " " +
                          data.companyVacant?.salario}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row vacancy__content">
          <div className="col-12 col-md-5">
            <div className="vacancy__sidebar bordered-box">
              <div className="bordered-box__header">
                <div className="bordered-box__header-title">Información</div>
              </div>
              <div className="vacancy__sidebar-content">
                <ul>
                  <li>
                    <strong>Empresa: </strong>
                    {data.companyVacant?.companyProfileId.name ?? ""}
                  </li>
                  <li>
                    <strong>Sitio Web: </strong>
                    <a
                      href={Url(data.companyVacant?.companyProfileId.webSite)}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {Url(data.companyVacant?.companyProfileId.webSite)}
                    </a>
                  </li>
                  <li>
                    <strong>Sector: </strong>
                    {data.companyVacant?.companyProfileId.sectorId.name ?? ""}
                  </li>
                  <li>
                    <strong>Ubicación: </strong>
                    {data.companyVacant?.companyProfileId.ubication ?? ""}
                  </li>
                  <li>
                    <strong>Año de Fundación: </strong>
                    {data.companyVacant?.companyProfileId.fundation ?? ""}
                  </li>
                  <li>
                    <strong>Empleados: </strong>
                    {data.companyVacant?.companyProfileId.employes ?? ""}
                  </li>
                </ul>
                <Link
                  to={{
                    pathname: "/user/PerfilEmpresa",
                    state: {
                      empresa: data.companyVacant?.companyProfileId.name,
                      logo: data.companyVacant?.companyProfileId
                        .profileImagePath,
                      profileId:
                        data.companyVacant?.companyProfileId.companyProfileId,
                    },
                  }}
                  className="btn btn--gradient btn--small"
                >
                  Ver Perfil
                </Link>
                <ul className="social-media">
                  {data.companyVacant?.companyProfileId.linkTwitter !== "" ? (
                    <li>
                      <a
                        href={
                          Url(
                            data.companyVacant?.companyProfileId.linkTwitter
                          ) ?? ""
                        }
                      >
                        <i class="fab fa-twitter-square"></i>
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {data.companyVacant?.companyProfileId.linkFacebook !== "" ? (
                    <li>
                      <a
                        href={
                          Url(
                            data.companyVacant?.companyProfileId.linkFacebook
                          ) ?? ""
                        }
                      >
                        <i class="fab fa-facebook-square"></i>
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {data.companyVacant?.companyProfileId.linkInstagram !== "" ? (
                    <li>
                      <a
                        href={
                          Url(
                            data.companyVacant?.companyProfileId.linkInstagram
                          ) ?? ""
                        }
                      >
                        <i className="fab fa-instagram-square"></i>
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="vacancy__description bordered-box">
              <div className="bordered-box__header">
                <div className="bordered-box__header-title">
                  Descripción del Puesto
                </div>
                <p>{data.companyVacant?.acercaVacante}</p>
              </div>
              <div className="bordered-box__body">
                <div className="bordered-box__header-title">
                  Responsabilidades
                </div>
                <p>{data.companyVacant?.acercaVacante}</p>
                <div className="bordered-box__header-title">
                  Requisitos, Habilidades/Aptitudes
                </div>
                <p>
                  {data.listSkills
                    ?.map(function (lstSkills) {
                      return lstSkills.skillName;
                    })
                    .join(" - ")}
                </p>
                <div className="bordered-box__header-title">
                  Idiomas requeridos
                </div>
                <p>
                  {data.listIdiomas
                    ?.map(function (lstIdioms) {
                      return lstIdioms.idioma;
                    })
                    .join(" - ")}
                </p>
                <div className="bordered-box__header-title">Beneficios</div>
                <p>{data.companyVacant?.beneficios}</p>
                <div className="bordered-box__header-title">Comentarios</div>
                <p>{data.companyVacant?.comentarios}</p>
                <div className="bordered-box__header-title">
                  Motocicleta/Vehiculo
                </div>
                <p>
                  {data.companyVacant?.motocicleta ? "Si" : "No"} /{" "}
                  {data.companyVacant?.vehiculo ? "Si" : "No"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom-content mt-2">
        <div className="container">
          <div className="button">
            {data.aplico ? (
              <button className="btn btn--gradient" onClick={aplicarVacante}>
                Cancelar
              </button>
            ) : (
              <button
                className="btn btn--gradient"
                data-bs-toggle="modal"
                data-bs-target="#kr-modal"
                data-title="Experiencia"
                onClick={aplicarVacante}
              >
                Aplicar
              </button>
            )}

            <button
              type="button"
              className="btn btn--gradient"
              onClick={guardarVacante}
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
      <div
        id="kr-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={h}>
              <h3 htmlFor="cargo">
                Tu aplicación ha sido enviada exitosamente
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        id="favorite-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={h}>
              <h3 htmlFor="cargo">
                Tu vacante de interés ha sido guardada en tus favoritos.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Vacante;
